import type { ContentfulClientApi } from "contentful";

export const getGuideIcon = async (
    contentfulClient: ContentfulClientApi<undefined>,
    icon: string,
): Promise<{ icon: string; url?: string }> => {
    const assets = await contentfulClient.getAssets({ "metadata.tags.sys.id[in]": ["exWoGuide"] });
    const url = assets.items.find((asset) => asset.fields.title === icon)?.fields.file?.url;
    return { icon, url };
};
